import { render, staticRenderFns } from "./RbuSectionFluctuationRow.vue?vue&type=template&id=9f6c8620"
import script from "./RbuSectionFluctuationRow.vue?vue&type=script&lang=js"
export * from "./RbuSectionFluctuationRow.vue?vue&type=script&lang=js"
import style0 from "./RbuSectionFluctuationRow.vue?vue&type=style&index=0&id=9f6c8620&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports